var app = angular.module("leonardo");

var ReportsPropertyListFilters = function(
  $scope,
  $controller,
  $timeout,
  $rootScope,
  ReportService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersProperty;
  
  $scope.group_options.push({ id: 'managed_by', name: 'Managed By' });

  $scope.filters_options = [];

  $scope.initOptions = function() {
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'zero_activity_logged',
        name: 'Zero activity logged',
        label: 'Zero Activity',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'zero_notes_added',
        name: 'Zero notes added',
        label: 'Zero Notes',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'levels',
        name: 'Property Address',
        label: 'Property Address',
        inline: false,
        type: 'levels',
        condition: true,
        conflicts: []
      },
      {
        id: 'fields_active',
        name: 'Fields To Show',
        label: 'Fields To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.fieldsReportProperty,
        conflicts: []
      },
      {
        id: 'extra_fields',
        name: 'Database IDs To Show',
        label: 'Database IDs To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.propertyIdFields,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_PROPERTY);
  }, 100);

};

app.controller('ReportsPropertyListFilters', [
  '$scope',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  ReportsPropertyListFilters
]);
